module.exports = __webpack_public_path__ + "media/images/baito-kun@2x-97ef65ffff765a30863b273d7b6d5ee5.png";